






































































import Popper from "popper.js";
import {
  defineComponent,
  nextTick,
  ref,
  reactive,
  watch,
  computed
} from "@vue/composition-api";

import store from "@/store/root";
import { format } from "date-fns";

export default defineComponent({
  name: "DocumentDropdown",
  props: {
    documents: { type: Array }
  },
  setup(props, context) {
    const button = ref<HTMLElement | null>(null);
    const popover = ref<HTMLElement | null>(null);
    const popper = ref<Popper | null>(null);

    const state = reactive({
      document: null,
      index: null
    });

    const change = ({ document, index }: Record<string, any>) => {
      state.document = document;
      state.index = index;
      context.emit("change", { document, index });
      hide();
    };

    const close = (event: Event) => {
      const element = popover.value;

      if (
        element &&
        element.offsetParent &&
        event.target &&
        !element.contains(event.target)
      )
        hide();
    };

    const hide = () => {
      if (popper.value) {
        popper.value.destroy();
        popper.value = null;
      }

      document.removeEventListener("close", close);
    };

    const show = () => {
      if (!button.value || !popover.value) return;

      popper.value = new Popper(button.value, popover.value, {
        placement: "bottom"
      });

      window.setTimeout(() => {
        document.addEventListener("click", close, true);
      }, 100);

      nextTick(() => {
        if (popper.value) popper.value.update();
      });
    };

    watch(
      () => props.documents,
      documents => change({ document: documents[0], index: 0 })
    );

    change({ document: props.documents[0], index: 0 });

    const status = computed(() => store.state.status);

    return { button, popover, popper, state, status, show, change };
  }
});
